
const updateClassInHtmlElement = function(targetElementID, classNamesToRemoveArray ,  classNamesToAddArray){
    let htmlElement = document.getElementById(targetElementID);
    //console.log("updateClassInHtmlElement-htmlElement:" , htmlElement);
    if(htmlElement != null){
        for(let i = 0; i< classNamesToRemoveArray.length; i++){
            const classToRemove = classNamesToRemoveArray[i];
            htmlElement.classList.remove(classToRemove);
        }

        for(let j = 0; j < classNamesToAddArray.length; j++){
            const classToAdd = classNamesToAddArray[j];
            htmlElement.classList.add(classToAdd);
        }       
    }
}

const setButtonOn = function(btnElementId, classToAdd){
    const btnElement = document.getElementById(btnElementId);   
    if(btnElement != null){
        btnElement.classList.add(classToAdd);       
    }
}

const setButtonOff = function(btnElementId, classToRemove){
    const btnElement = document.getElementById(btnElementId);   
    if(btnElement != null){
        btnElement.classList.remove(classToRemove);       
    }
}

function toggleUlElement(targetUlElementID, classToHide, classToDisplay ){
    const ulElement = document.getElementById(targetUlElementID);
    if(ulElement != null){
        //console.log(ulElement);
        if(ulElement.classList.contains(classToHide)){
            ulElement.classList.remove(classToHide);
            ulElement.classList.add(classToDisplay);
            return;
        }
        if(ulElement.classList.contains(classToDisplay)){
            ulElement.classList.remove(classToDisplay);
            ulElement.classList.add(classToHide);
        }
    }
}

const HtmlElementFormatter = Object.freeze({
    updateClassInHtmlElement : updateClassInHtmlElement,
    setButtonOn : setButtonOn,
    setButtonOff : setButtonOff,
    toggleUlElement : toggleUlElement
});


export default HtmlElementFormatter;